import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import Dropzone from 'react-dropzone';
import classnames from 'classnames';
import update from 'immutability-helper';
import { Upload, Close } from 'components/Icons';
import Progress from 'react-progressbar';
import uuidv4 from 'uuid/v4';
import { BASE_URL } from 'consts';
import Request from 'superagent';
import { formatBytes } from 'helpers/utils';

const styles = theme => ({
  container: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    padding: theme.spacing(2),
  },
  subtitle: {
    fontSize: '0.9em',
    color: '#4EA2FF',
    marginBottom: 8,
    marginLeft: 10,
    fontWeight: 'bold',
  },
  centerContainer: {
    display: 'flex',
    flexGrow: 1,
  },
  files: {
    flexDirection: 'column',
    flexWrap: 'nowrap',
    padding: 10,
  },
  filesShow: {
    display: 'flex',
  },
  filesHide: {
    display: 'none',
  },
  fileContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  fileContent: {
    display: 'flex',
    flexGrow: 1,
  },
  fileLeft: {
    color: '#4EA2FF',
    alignSelf: 'center',
    fontSize: '0.8em',
    paddingLeft: 10,
  },
  fileRight: {
    paddingTop: 2,
    cursor: 'pointer',
    minHeight: 26,
  },
  progressBar: {
    height: 2,
    minHeight: 2,
  },
  dropzone: {
    flexGrow: 1,
    display: 'flex',
    borderStyle: 'dashed',
    borderWidth: 2,
    borderColor: '#A5D0FF',
    borderRadius: 5,
    cursor: 'pointer',
    padding: 20,
    minHeight: 100,
    justifyContent: 'center',
    alignItems: 'center',
    height: 'auto',
  },
  dropzoneText: {
    color: '#4EA2FF',
    fontSize: '0.8em',
    marginLeft: 10,
    marginBottom: 5,
  },
  bottomContainer: {
    display: 'flex',
    marginTop: 10,
    justifyContent: 'flex-end',
  },
});

export class Uploader extends Component {
  state = {
    files: [],
  };

  componentDidMount() {
    this.props.history.push('/dashboard');
  }

  deleteFileFromQueue = key => {
    const index = this.state.files.map(el => el.key).indexOf(key);
    if (index >= 0) {
      this.setState(prevState => ({
        files: update(prevState.files, { $splice: [[index, 1]] }),
      }));
    }
  };

  onDrop = accepted => {
    // Insert extra attributes
    accepted.forEach(f => {
      f.progress = 0;
      f.key = uuidv4();
    });
    this.setState(update(this.state, { files: { $push: accepted } }));
  };

  updateFileProgress = (fileKey, progress) => {
    const copy = this.state.files.slice();
    const index = copy.map(el => el.key).indexOf(fileKey);
    copy[index].progress = progress;
    this.setState({ files: copy });
  };

  uploadFiles = () => {
    this.state.files.forEach(file => {
      Request.post(`${BASE_URL}/files/upload`)
        .attach('file', file)
        .set('Authorization', this.props.auth.token)
        .timeout(3600000) // 1 hour
        .on('progress', event => {
          this.updateFileProgress(file.key, Math.round(event.percent || 100));
        })
        .end((err, res) => {
          if (!err && res.statusCode === 201) {
            this.deleteFileFromQueue(file.key);
            this.props.onAppendFileToLibrary(res.body);
          }
        });
    });
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.container}>
        <div className={classes.centerContainer}>
          <Dropzone
            className={classes.dropzone}
            accept={
              'video/3gpp, video/mp4, video/mpeg, video/ogg, ' +
              'video/quicktime, video/webm, video/x-m4v, ' +
              'video/ms-asf, video/x-ms-wmv, video/x-msvideo, ' +
              'audio/basic, auido/L24, audio/mid, audio/mpeg, ' +
              'audio/mp4, audio/x-aiff, audio/x-mpegurl, ' +
              'audio/vnd.rn-realaudio, audio/ogg, audio/vorbis, ' +
              'audio/vnd.wav, audio/mp3'
            }
            onDrop={this.onDrop}
          >
            <Upload color="#4EA2FF" />
            <span className={classes.dropzoneText}>Drop your files here</span>
          </Dropzone>
          <div
            className={classnames(
              classes.files,
              this.state.files && this.state.files.length
                ? classes.filesShow
                : classes.filesHide
            )}
          >
            <span className={classes.subtitle}>Upload queue</span>
            {this.state.files.map(file => {
              return (
                <div key={file.key} className={classes.fileContainer}>
                  <div className={classes.fileContent}>
                    <div className={classes.fileLeft}>
                      {`${file.name} (${formatBytes(file.size)})`}
                    </div>
                    <div
                      className={classes.fileRight}
                      onClick={() => this.deleteFileFromQueue(file.key)}
                    >
                      <Close size="small" color="#4EA2FF" />
                    </div>
                  </div>
                  <div className={classes.progressBar}>
                    <Progress completed={file.progress} height={2} color="#4EA2FF" />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className={classes.bottomContainer}>
          <Button
            variant="text"
            color="primary"
            disabled={!(this.state.files && this.state.files.length)}
            onClick={() => this.uploadFiles()}
          >
            upload files
          </Button>
        </div>
      </div>
    );
  }
}

Uploader.propTypes = {
  classes: PropTypes.object.isRequired,
  onAppendFileToLibrary: PropTypes.func.isRequired,
};

export default withStyles(styles)(Uploader);
